import Vue from "vue";
import Router from "vue-router";
import PageNotFound from "./views/PageNotFound.vue";
import CieloFarol from "./views/CieloFarol.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () => {
        window.location = "https://overmediacast.com";
      }
    },
    {
      path: "/not-found",
      name: "pageNotFound",
      component: PageNotFound
    },
    {
      path: "/cielo-farol",
      name: "CieloFarol",
      component: CieloFarol
    },
    {
      path: "/:slug",
      name: "slug",
      // eslint-disable-next-line
      component: () => import(/* webpackChunkName: "slug" */ "./views/SlugHandler.vue")
    },
    // {
    //   path: "/u/:slug",
    //   name: "slug-unique",
    //   // eslint-disable-next-line
    //   component: () => import(/* webpackChunkName: "slug" */ "./views/SlugURLUniqueHandler.vue")
    // },
    {
      path: "/:client_name/:video_name",
      name: "brandChannel",
      // eslint-disable-next-line
      component: () => import(/* webpackChunkName: "brandChannel" */ "./views/BrandChannel")
    }
  ]
});
